import { render, staticRenderFns } from "./PresentationItem.vue?vue&type=template&id=8bfcd01c&scoped=true&"
import script from "./PresentationItem.vue?vue&type=script&lang=js&"
export * from "./PresentationItem.vue?vue&type=script&lang=js&"
import style0 from "./PresentationItem.vue?vue&type=style&index=0&id=8bfcd01c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfcd01c",
  null
  
)

export default component.exports